import React from 'react';
import ReactDOM from 'react-dom';
import { ConfigProvider } from "antd";
import zhCN from 'antd/es/locale/zh_CN'
import App from './App';
import { qtInit } from 'ruigu-utils'

// styl
import './index.styl';
import './assets/styl/base.styl';
import './assets/styl/flex.styl';
import './assets/styl/public.styl';

if (['test', 'dev'].includes(process.env.REACT_APP_ENV)) {
  console.log(`QT: 埋点上报-初始化: qtInit('xa9jcl3x532eotqnfq1y088b', 'test')`);
  qtInit('xa9jcl3x532eotqnfq1y088b', 'test');
} else {
  console.log(`QT: 埋点上报-初始化: qtInit('8b6orwrfn6thtl8omcrf1oi2', '')`);
  qtInit('8b6orwrfn6thtl8omcrf1oi2', '');
}

ReactDOM.render(
    <ConfigProvider locale={zhCN}>
      <App />
    </ConfigProvider>,
  document.getElementById('root')
);
